<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle"><h3 class="label">ICCID:</h3><h3 class="value">{{ item.iccid }}</h3></div>
        <div class="methodTitle">
          <h3 class="label">订单编号:</h3>
          <h3 class="value" v-if="type === '充值'">{{ item.recharge_id }}</h3>
          <h3 class="value" v-else>{{ item.addflow_id }}</h3>
        </div>
        <div class="methodTitle">
          <h3 class="label">时间:</h3>
          <h3 class="value" v-if="type === '充值'">{{ item.recharge_date }}</h3>
          <h3 class="value" v-else>{{ item.rechargeDate }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li> <h3>代理商名称</h3> <p>{{ item.agent_name }}</p> </li>
            <li> <h3>套餐名称</h3> <p>{{ item.pk_name }}</p> </li>
            <li> <h3>充值金额</h3> <p>{{ item.recharge_amount }} 元</p> </li>
            <li v-if="type === '充值'"> <h3>分润金额</h3> <p>{{ item.profit_amount }} 元</p> </li>
            <li v-else> <h3>充值流量</h3> <p>{{ item.flow }}MB</p> </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="zwf"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    },
    type: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 350px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      flex: 2;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        padding: 30px 0 0 40px;
        h3 {
          font-size: 30px;
          color: #838383;
          line-height: 20px;
          font-weight: 400;
        }
        .label {
          flex: 1;
          width: 150px;
          color: #000;
        }
        .value {
          flex: 2;
        }
      }
      .methodSlidebt {
        padding: 30px 40px 0;
        ul {
          display: flex;
          justify-content: space-between;
          height: 120px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-3.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .zwf {
    height: 15px;
  }
</style>
